var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pt-2 pb-4",attrs:{"id":"puckslides"}},[_c('slideshow',{attrs:{"slides":[
      _vm.assetUrl('img/carousel/seniors-alone.jpg'),
      _vm.assetUrl('img/carousel/unexpected-moments.jpg'),
      _vm.assetUrl('img/carousel/safe-connected.jpg'),
      _vm.assetUrl('img/carousel/mutual-care.jpg')
    ],"folder":"","width":"1200","height":"600","label-pre-fix":"puck.slides"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }